module.exports = __webpack_public_path__ + "static/media/certificate3.88eb2d43.webp";